module.exports = __webpack_public_path__ + "static/img/career-course-rszw.ce9b665b.png";